import Node from './Node';

export default class Task extends Node {
  nodeType = 'Task';
}
